<template>
  <Modal v-model="openModal" draggable title="作业情况" footer-hide width="400">
    <p>作业完成率</p>
    <Progress :percent="item.progress" :stroke-width="5" />
    <Row style="margin-top: 20px">
      <Col span="12"
        ><ly-form-item label="开始作业">{{ item.start }}</ly-form-item></Col
      >
      <Col span="12"
        ><ly-form-item label="预计结束">{{ item.end }}</ly-form-item></Col
      >
      <Col span="12"
        ><ly-form-item label="要求里程"
          >{{ item.mustMileage }} km</ly-form-item
        ></Col
      >
      <Col span="12"
        ><ly-form-item label="实际里程"
          >{{ item.actualMileage }} km</ly-form-item
        ></Col
      >
    </Row>
    <ul v-show="false" id="sashui">
      <li
        v-for="(x, index) in item.lights"
        :key="index"
        :class="{ active: x.isOpen }"
      >
        <div class="isopen">{{ x.isOpen ? "开" : "关" }}</div>
        <p class="name">{{ x.name }}</p>
      </li>
    </ul>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      openModal: false,
      item: {
        start: "--:--",
        end: "--:--",
        progress: 0,
        lights: [
          {
            name: "左洒水",
            isOpen: false,
          },
          {
            name: "右洒水",
            isOpen: false,
          },
          {
            name: "前洒水",
            isOpen: false,
          },
          {
            name: "后洒水",
            isOpen: false,
          },
        ],
        actualMileage: 0,
        mustMileage: 0,
      },
    };
  },
  methods: {
    open(v) {
      this.openModal = true;
      this.reset();
      this.getData(v.deviceId);
    },
    getData(id) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.upf + "/work/getWork/gtCar",
        data: { deviceId: id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          if (data == null) {
            return;
          }
          this.item.progress = data.finishRate;
          this.item.start = this.utils.time(data.startTime, "hhmm");
          this.item.end = this.utils.time(data.expEndTime, "hhmm");
          this.item.actualMileage = data.actualMileage;
          this.item.mustMileage = data.mustMileage;
          for (let i = 0; i < data.eventList.length; i++) {
            for (let j = 0; j < this.item.lights.length; j++) {
              if (data.eventList[i].name == this.item.lights[j].name) {
                this.item.lights[j] = data.eventList[i];
              }
            }
          }
        }
      });
    },
    reset() {
      this.item = {
        start: "--:--",
        end: "--:--",
        progress: 0,
        lights: [
          {
            name: "左洒水",
            isOpen: false,
          },
          {
            name: "右洒水",
            isOpen: false,
          },
          {
            name: "前洒水",
            isOpen: false,
          },
          {
            name: "后洒水",
            isOpen: false,
          },
        ],
        actualMileage: 0,
        mustMileage: 0,
      };
    },
  },
};
</script>
<style lang="">
#sashui {
  display: flex;
  margin-top: 20px;
}
#sashui li {
  flex: 1;
  text-align: center;
}
#sashui li .isopen {
  font-size: 18px;
  border: solid 4px #dadada;
  color: #b7b7b7;
  width: 50px;
  height: 50px;
  line-height: 40px;
  border-radius: 50px;
  text-align: center;
  margin: auto;
  margin-bottom: 4px;
}
#sashui li.active .isopen {
  border: solid 4px #14d517;
  color: #14d517;
}
</style>



// WEBPACK FOOTER //
// src/components/locate/sashuiche.vue